import { render } from "./Login-old.vue?vue&type=template&id=41aa9ff6"
import script from "./Login-old.vue?vue&type=script&lang=js"
export * from "./Login-old.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__